import { Route, Routes } from 'react-router-dom';
import Page404 from '../../views/user/Auth/Page404';
import NavGrievanceTickets from '../../views/Grievance/NavGrievanceTickets';
import { useSelector } from 'react-redux';
import useRoles from '../../Hooks/useRoles';

const GrievanceRouter = () => {
  useRoles('Grievance');
  const role = useSelector((state) => state.role);

  return (
    <Routes>
      {role.navChild.includes('Grivance Admin') && (
        <Route path="grievance-tickets-admin" element={<NavGrievanceTickets isAdmin />} />
      )}
      <Route path="nav-grievance-tickets" element={<NavGrievanceTickets />} />

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default GrievanceRouter;
